import { ArrowUturnRightIcon, XMarkIcon } from '@heroicons/react/16/solid';
import { Button } from 'react-daisyui';
import { useModalsContext } from '../../../../../../providers/ModalsProvider/Modals.context';
import { ChatEnum } from '../../../../Chat.enum';
import { useChatContext } from '../../../../Chat.hook';
import { useMessageBarContext } from '../../MessageBar.hook';

export default function ResendAction() {
  const { resendIds, isResending, setIsResending, setResendIds } =
    useChatContext();
  const { setShowResendModal } = useModalsContext();
  const { setSelectedAction } = useMessageBarContext();

  function onClickClose() {
    setResendIds([]);
    setIsResending(false);
    setSelectedAction(ChatEnum.CHAT);
  }

  function onClickResend() {
    setIsResending(false);
    setShowResendModal(true);
  }

  return (
    isResending && (
      <div className="absolute w-full bg-base-100 z-[51] p-6 flex justify-between items-center">
        <div className="flex items-center gap-2">
          <Button size="sm" color="ghost" onClick={onClickClose}>
            <XMarkIcon className="w-5 h-5" />
          </Button>
          <span>{resendIds.length} Seleccionados</span>
        </div>

        <div>
          <Button
            size="sm"
            color="ghost"
            onClick={onClickResend}
            disabled={!resendIds.length}
          >
            <ArrowUturnRightIcon className="w-5 h-5" />
          </Button>
        </div>
      </div>
    )
  );
}
